<template>
  <div>

    <v-container flex>
      <v-layout
        style="margin-bottom: 64px;"
        text-xs-center
        wrap
      >
        <v-flex xs12 md10 xl8 offset-md1 offset-xl2  class="mb-3 mt-3">
      <Calendar></Calendar>
        </v-flex>

      </v-layout>

    </v-container>
  </div>
</template>

<script>

import Calendar from '../components/Calendar'

export default {
  components: {
    Calendar
  },
  props: {

  },
  data () {
    return {}
  }

}
</script>

<style>

</style>
